export default "__VITE_ASSET__BlnzjlAq__"